import React from "react";

/**
 * Modal per visualizzare la lista degli studenti che hanno completato un compito
 * @param {boolean} isOpen - Se il modal è aperto
 * @param {function} onClose - Callback per chiudere il modal
 * @param {string} titoloCompito - Titolo del compito
 * @param {Array} studenti - Lista degli studenti con i dettagli del completamento
 * @param {boolean} isLoading - Se sta caricando i dati
 */
const CompitoStudentiModal = ({
  isOpen,
  onClose,
  titoloCompito,
  studenti,
  isLoading,
}) => {
  if (!isOpen) return null;

  console.log("🔵 [CompitoStudentiModal] Rendering con:", {
    isOpen,
    titoloCompito,
    studenti,
    numeroStudenti: studenti ? studenti.length : 0,
    isLoading,
  });

  const modalBackgroundStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.7)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 50,
  };

  const modalStyle = {
    backgroundColor: "white",
    padding: "24px",
    borderRadius: "8px",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    width: "800px",
    maxWidth: "90%",
    maxHeight: "80vh",
    overflowY: "auto",
    zIndex: 60,
  };

  const buttonStyle = {
    padding: "10px 20px",
    borderRadius: "4px",
    cursor: "pointer",
    fontWeight: "bold",
    backgroundColor: "#A00008",
    color: "#fff",
    border: "none",
  };

  const tableStyle = {
    width: "100%",
    borderCollapse: "collapse",
    marginTop: "20px",
  };

  const thStyle = {
    backgroundColor: "#f0f0f0",
    padding: "12px",
    textAlign: "left",
    borderBottom: "2px solid #ddd",
    fontWeight: "bold",
  };

  const tdStyle = {
    padding: "12px",
    borderBottom: "1px solid #ddd",
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div style={modalBackgroundStyle} onClick={handleOverlayClick}>
      <div style={modalStyle} onClick={(e) => e.stopPropagation()}>
        <h2
          style={{
            textAlign: "center",
            fontSize: "1.5rem",
            fontWeight: "bold",
            marginBottom: "16px",
            color: "#333",
          }}
        >
          Studenti che hanno completato il compito
        </h2>

        <p
          style={{
            textAlign: "center",
            marginBottom: "24px",
            fontWeight: "bold",
            color: "#555",
            fontSize: "1.1rem",
          }}
        >
          {titoloCompito}
        </p>

        {isLoading ? (
          <div style={{ textAlign: "center", padding: "40px" }}>
            <p>Caricamento in corso...</p>
          </div>
        ) : studenti && studenti.length > 0 ? (
          <>
            <div style={{ marginBottom: "16px", color: "#666" }}>
              <strong>Totale studenti:</strong> {studenti.length}
            </div>
            <table style={tableStyle}>
              <thead>
                <tr>
                  <th style={thStyle}>Nome</th>
                  <th style={thStyle}>Cognome</th>
                  <th style={thStyle}>Email</th>
                  <th style={thStyle}>Data Completamento</th>
                </tr>
              </thead>
              <tbody>
                {studenti.map((studente, index) => {
                  // Supporta sia 'id' che 'id_studente', sia 'mail' che 'email'
                  const studenteId = studente.id || studente.id_studente;
                  const studenteMail = studente.mail || studente.email;

                  return (
                    <tr
                      key={studenteId || index}
                      style={{
                        backgroundColor: index % 2 === 0 ? "#fff" : "#f9f9f9",
                      }}
                    >
                      <td style={tdStyle}>{studente.nome || "-"}</td>
                      <td style={tdStyle}>{studente.cognome || "-"}</td>
                      <td style={tdStyle}>{studenteMail || "-"}</td>
                      <td style={tdStyle}>
                        {studente.data_completamento
                          ? new Date(
                              studente.data_completamento
                            ).toLocaleDateString("it-IT")
                          : "-"}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </>
        ) : (
          <div
            style={{
              textAlign: "center",
              padding: "40px",
              color: "#999",
              fontSize: "1rem",
            }}
          >
            Nessuno studente ha ancora completato questo compito.
          </div>
        )}

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "24px",
          }}
        >
          <button style={buttonStyle} onClick={onClose}>
            Chiudi
          </button>
        </div>
      </div>
    </div>
  );
};

export default CompitoStudentiModal;
